import { render, staticRenderFns } from "./NewRecord.vue?vue&type=template&id=2204e56f"
import script from "./NewRecord.vue?vue&type=script&lang=js"
export * from "./NewRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports